import { render, staticRenderFns } from "./products.vue?vue&type=template&id=685e5af0&scoped=true"
import script from "./products.vue?vue&type=script&lang=js"
export * from "./products.vue?vue&type=script&lang=js"
import style0 from "./products.vue?vue&type=style&index=0&id=685e5af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685e5af0",
  null
  
)

export default component.exports